import { TeamAccessType } from '@showbie-socrative/socrative-utils';

import { TeamsMembersData } from '../../../../api/teams/getTeamsMembers';

export function countSeatsUsed(teamMembers: TeamsMembersData = []) {
  return (teamMembers ?? []).reduce((acc, member) => {
    if (member.accessLevel === TeamAccessType.Paid) {
      return acc + 1;
    }
    return acc;
  }, 0);
}

interface SeatsUsedParams {
  teamMembers: TeamsMembersData;
  totalSeats: number;
}

export function calculateSeatsUsed({
  teamMembers,
  totalSeats,
}: SeatsUsedParams) {
  const seatsUsed = countSeatsUsed(teamMembers);
  const seatsAvailable = totalSeats - seatsUsed;
  return seatsAvailable;
}
